/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit, signal} from '@angular/core';

import {ReleaseNotesHelper} from '../../../components/util/release-notes-helper.service';
import template from './release-notes-list-page.component.html';
import {ReleaseNoteCardComponent} from './release-note-card.component';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';

@Component({
  standalone: true,
  imports: [...SIMPLE_PAGE_IMPORTS, ReleaseNoteCardComponent],
  selector: 'adn-release-notes-list-page',
  template
})
export class ReleaseNotesListPageComponent implements OnInit {
  readonly notes = signal<any[]>([]);
  showList = 'ACTIVE';
  readonly loaded = signal(false);
  readonly loadError = signal('');

  constructor(private readonly releaseNotesHelper: ReleaseNotesHelper) {
  }

  ngOnInit(): void {
    this.loadNotes();
  }

  selectShowList(showList: string): void {
    if (this.showList === showList) {
      return;
    }
    this.showList = showList;
    this.loadNotes();
  }

  private loadNotes(): void {
    this.loaded.set(false);
    this.loadError.set('');
    this.releaseNotesHelper.query(null, true, this.showList).then((data: any[]) => {
      this.notes.set(data || []);
      this.loaded.set(true);
    }).catch(() => {
      this.notes.set([]);
      this.loadError.set('Release notes could not be loaded.');
      this.loaded.set(true);
    });
  }
}
